// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1lRaZ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3MC_2"};